import React, {useEffect, useState} from 'react';
import {InputNumber, message, Radio} from 'antd';
import {Button, Col, Input, Layout, Row, Select, Space, Table, TimePicker, Checkbox} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'
import ProPortalHeader from "../../../componets/ProPortalHeader";
import ProfileRow from "../../../componets/ProfileRow";
import Navigator from "../../../componets/Navigator";
import Img from "./Static Textura with Start Screen.png"
import {get_api, post_api} from "../../../serverTemp";
import {useLocation, useNavigate} from "react-router-dom";
import {ReactComponent as RepeatIcon} from './Repeat Once.svg'
import {ShuffleIcon} from "../../Icons";
import backButton from './img/Back button.svg';
import {DAYS_A_WEEK} from "../../../../constants/proConstants";
import {useImmerReducer} from "use-immer";
import {initialState, reducer} from "./reducer";
import {RemoveIcon} from "./svg";

const Hardware = (props) => {
    const [dsState, dispatch] = useImmerReducer(reducer, initialState)
    const {state} = useLocation();
    const {deviceData} = state
    const [schedule, setSchedule] = useState([])
    const [deviceName, setDeviceName] = useState(deviceData.name)
    const [infoChanged, setInfoChanged] = useState(false)
    const [nameChanged, setNameChanged] = useState(false)
    const navigate = useNavigate()
    // 0:Schedule 1:Setting 2:Control
    const [cur, setCur] = useState(0)
    const [newScheduleOpen, setNewScheduleOpen] = useState(false)
    useEffect(() => {
        get_api(`/textura/schedules?textura_id=${deviceData.id}`).then(res => {
            setSchedule(res.data)
        })
    }, [])

    const columns = [
        {
            title: 'Textura Name',
            // dataIndex: 'name',
            key: 'name',
            render: (_, record) => (
                <span>
                {deviceData.name}
            </span>
            )
        },
        {
            title: 'Start time',
            dataIndex: 'start_time',
            key: 'start',
        },
        {
            title: 'End time',
            key: 'end',
            dataIndex: 'end_time',
        },
        {
            title: <span style={{
                display: 'flex',
                // justifyContent: 'center',
            }}>Day of the week</span>,
            dataIndex: 'days',
            key: 'week',
            render: (days, record) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, idx) => {
                        return (
                            <span style={days.includes(idx) ? {
                                background: '#D9D9D9',
                                borderRadius: '50%',
                                width: '20px',
                                textAlign: 'center'
                            } : {}} key={idx}>
                                {d}
                            </span>
                        );
                    })}
                </div>
            )
        },
        {
            title: <span style={{
                display: 'flex',
                justifyContent: 'center',
            }}>Remove</span>,
            key: 'remove',
            render: (_, record) => (
                <Space size="middle" style={{
                    display: 'flex',
                    justifyContent: 'center',
                }}
                       onClick={() => {
                           console.log(deviceData.id, record.id)
                           post_api('/textura/delete/schedule', {
                               textura_ids: [deviceData.id],
                               id: record.id
                           }).then(_ => window.location.reload())
                               .catch(error => console.error('Error:', error));
                       }}
                >
                    <RemoveIcon/>
                </Space>
            ),
        },
    ];
    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <Layout>
            <Content style={{paddingTop: '0.625rem'}}>
                <ProPortalHeader/>
                <ProfileRow/>
                <Row>
                    <Layout>
                        <Navigator/>
                        <Layout style={{marginBottom: '10vh'}}>
                            <Row style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '50px',
                                marginLeft: '20px'
                            }}>
                                <img src={backButton} alt="BackButton" className='BackButtonIcon'
                                     style={{marginRight: '60px', cursor: "pointer"}} onClick={handleBackClick}/>
                                <p className='hard-title' style={{margin: 0}}>Hardware detail</p>
                            </Row>
                            <Row justify={"center"}>
                                <Col span={8} lg={8}>
                                    <div className={'hard-img-div'}>
                                        <img src={Img} className={'hard-img'} alt={'img'}/>
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <Row justify={"center"} className={'hard-row'}>
                                        <Input className={'hard-input'}
                                               placeholder="Name"
                                               onChange={(e) => {
                                                   const userInput = e.target.value;
                                                   setDeviceName(userInput);
                                                   setNameChanged(true)
                                               }}
                                               defaultValue={deviceName}/>
                                        <Input className={'hard-input'} placeholder="Subscription"
                                               disabled={true}
                                               defaultValue={
                                                   localStorage.getItem('subscription')
                                               }/>
                                    </Row>
                                    <Row justify={"center"} className={'hard-row'}>
                                        <Input className={'hard-input'} placeholder="SN"
                                               defaultValue={deviceData.sn}
                                               disabled={true}
                                        />
                                        <Input className={'hard-input'} placeholder="Portrait"
                                               disabled={true}
                                               defaultValue={deviceData.angle === 90 || deviceData.angle === 270 ?
                                                   'Portrait' : 'Landscape'}/>
                                    </Row>
                                    <Row justify={"center"} className={'hard-row'}>
                                        <Input className={'hard-input'} placeholder="Group"
                                               defaultValue={deviceData.group} disabled={true}/>
                                        <Button className={'hard-group-btn'}
                                                onClick={() => {
                                                    window.location.href = '/proportal/ProportalGroup'
                                                }}
                                        >
                                            Manage Groups
                                        </Button>
                                    </Row>
                                    <Row className={'hard-row'} style={{margin: '2rem 0 0 -42.3vw'}}>
                                        <Button className={'hard-btn'}
                                                onClick={_ => setCur(0)}>
                                            Schedule
                                        </Button>
                                        <Button className={'hard-btn'}
                                                onClick={_ => setCur(1)}
                                                style={{margin: '0 0 0 -3rem'}}>
                                            Setting
                                        </Button>
                                        <Button className={'hard-btn'}
                                                onClick={_ => setCur(2)}
                                                style={{margin: '0 0 0 -3rem'}}>
                                            Control
                                        </Button>
                                    </Row>
                                    {cur === 0 && <><Row>
                                        <p className={'hard-cur-sch'}>
                                            Current schedule
                                        </p>
                                    </Row>
                                        <Table style={{
                                            margin: '2rem 0rem 0 -2rem',
                                            borderRadius: '8px',
                                            border: '2px solid #FFF'
                                        }}
                                               columns={columns}
                                               dataSource={schedule}
                                               pagination={false}
                                        /></>}
                                    {cur === 1 && <div style={{margin: '0 0 0 -1rem'}}>
                                        {/*<Row justify={'start'} className={'hd-settings-txt'}*/}
                                        {/*     style={{margin: '2rem 0 0 0'}}*/}
                                        {/*>*/}
                                        {/*    <p>Orientation</p>*/}
                                        {/*</Row>*/}
                                        <Checkbox.Group
                                            style={{
                                                width: '100%',
                                                margin: '2rem 0 1rem 0'
                                            }}
                                            // onChange={onChange}
                                        >
                                            <Row justify={'start'}>
                                                <Col span={2}>
                                                    <span className={'hd-settings-txt'}>Angle</span>
                                                </Col>
                                                <Radio.Group
                                                    onChange={(e) => {
                                                        dispatch({type: 'update_meta', item: {angle: e.target.value}})
                                                    }}
                                                    value={dsState.metaData.angle}>
                                                    <Radio value={0} className={'jsb-txt'}>
                                                        <p className={'jsb-angle'}><span>0°</span> <span
                                                            className={'jsb-angle-span'}>Landscape</span></p>
                                                    </Radio>
                                                    <Radio value={90} className={'jsb-txt'}>
                                                        <p className={'jsb-angle'}><span>90°</span> <span
                                                            className={'jsb-angle-span'}>Portrait</span></p>
                                                    </Radio>
                                                    <Radio value={180} className={'jsb-txt'}>
                                                        <p className={'jsb-angle'}><span>180°</span> <span
                                                            className={'jsb-angle-span'}>Landscape</span><span
                                                            className={'jsb-angle-span'}>Flipped</span></p>
                                                    </Radio>
                                                    <Radio value={270} className={'jsb-txt'}>
                                                        <p className={'jsb-angle'}><span>270°</span> <span
                                                            className={'jsb-angle-span'}>Portrait</span><span
                                                            className={'jsb-angle-span'}>Flipped</span></p>
                                                    </Radio>
                                                </Radio.Group>
                                            </Row>
                                        </Checkbox.Group>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '1rem 0 0 0'}}
                                        >
                                            <p>Volume</p>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-ip'}>
                                            <InputNumber min={0} max={100}
                                                         defaultValue={dsState.metaData.volume}
                                                         onChange={val =>
                                                             dispatch({type: 'update_meta', item: {volume: val}})
                                                         }/>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '1rem 0 0 0'}}>
                                            <p>Brightness</p>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-ip'}>
                                            <InputNumber min={0} max={100}
                                                         defaultValue={dsState.metaData.brightness}
                                                         onChange={val =>
                                                             dispatch({type: 'update_meta', item: {brightness: val}})
                                                         }/>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '1rem 0 0 0', width: '100%'}}>
                                            <p>Image duration(seconds)</p>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-ip'}>
                                            <InputNumber min={0} max={86400}
                                                         defaultValue={dsState.metaData.imageDuration}
                                                         onChange={val =>
                                                             dispatch({type: 'update_meta', item: {imageDuration: val}})
                                                         }/>
                                        </Row>
                                        <Row className={'hard-final-row'} style={{
                                            margin: '4rem 0 0 -10vw',
                                            paddingBottom: '4rem'
                                        }}>
                                            <Button className={'hard-week-final-btn-mul-s'}
                                                    onClick={() => {
                                                        const curId = [deviceData?.id]
                                                        post_api('/textura/update/metadata', {
                                                            textura_ids: curId,
                                                            ...dsState.metaData
                                                        })
                                                    }}
                                            >
                                                Save
                                            </Button>
                                        </Row>
                                    </div>}
                                    {cur === 2 && <div>
                                        <div style={{
                                            margin: '2rem 0 0 -2rem', width: '20vw',
                                            borderRadius: '6px',
                                            border: '0px solid #E2E2E2', // Or simply 'none' if you don't need a border
                                            background: '#F4F4F4',
                                            boxShadow: '-2px -3px 10.4px -5px rgba(0, 0, 0, 0.18) inset'
                                        }}>
                                            <Row justify={'start'}>
                                                <p className={'zh-ml-schedule-modal-h'}>Playback Options</p>
                                            </Row>
                                            <Row justify={"start"} style={{margin: '1rem 0 0 0'}}>
                                                <p className={'zh-ml-schedule-modal-p'}>
                                                    When you use this particular function you
                                                    will need to assess your hardware
                                                </p>
                                            </Row>
                                            <Row justify={'start'} style={{margin: '3rem 0 2rem 0'}}>
                                                <Col span={12}>
                                                    <Row justify={'center'}>
                                                        <div className={'hd-control-div'} style={{
                                                            height: '2.6vw',
                                                            width: '6.2vw',
                                                            // marginLeft: '6vw'
                                                        }}>
                                                            <button className={'hd-control-btn'}
                                                                    style={{
                                                                        margin: '0 0 0 0.5rem',
                                                                        backgroundColor: dsState?.texturaPlayModeStatus === 2 ? '#A06174' : '#0E487A',
                                                                        width: '2vw',
                                                                        height: '2vw'
                                                                    }}
                                                                    onClick={_ => {
                                                                        const curId = [deviceData?.id]
                                                                        post_api('/textura/shuffle', {
                                                                            textura_ids: curId,
                                                                            texturaPlayModeStatus: 2
                                                                        })
                                                                            .then(() => dispatch({
                                                                                type: 'set_play_mode',
                                                                                payload: 2
                                                                            })).catch(error => console.log('error', error))
                                                                    }}
                                                            >
                                                                <RepeatIcon/>
                                                            </button>
                                                            <p className={'hd-control-p'} style={{
                                                                color: dsState?.texturaPlayModeStatus === 2 ? '#000' : '#D9D9D9',
                                                                // marginLeft: '1vw'
                                                            }}>
                                                                Repeat Single mode is on
                                                            </p>
                                                        </div>
                                                    </Row>
                                                    <Row justify={'center'} style={{marginTop: '1vh'}}>
                                                        <p>Repeat Single</p>
                                                    </Row>
                                                </Col>
                                                <Col span={12}>
                                                    <Row justify={'center'}>
                                                        <div className={'hd-control-div'} style={{
                                                            height: '2.6vw',
                                                            width: '6.2vw',
                                                        }}>
                                                            <button className={'hd-control-btn'}
                                                                    style={{
                                                                        margin: '0 0 0 0.5rem',
                                                                        backgroundColor: dsState?.texturaPlayModeStatus === 0 ? '#A06174' : '#0E487A',
                                                                        width: '2vw',
                                                                        height: '2vw'
                                                                    }}
                                                                    onClick={_ => {
                                                                        const curId = [deviceData?.id]
                                                                        post_api('/textura/shuffle', {
                                                                            textura_ids: curId,
                                                                            texturaPlayModeStatus: 0
                                                                        }).then(() => {
                                                                            dispatch({
                                                                                type: 'set_play_mode',
                                                                                payload: 0
                                                                            })
                                                                        }).catch(error => console.log('error', error))
                                                                    }}>
                                                                <ShuffleIcon/>
                                                            </button>
                                                            <p className={'hd-control-p'} style={{
                                                                color: dsState?.texturaPlayModeStatus === 0 ? '#000' : '#D9D9D9',
                                                            }}>
                                                                Shuffle mode is on
                                                            </p>
                                                        </div>
                                                    </Row>
                                                    <Row justify={'center'}
                                                         style={{marginTop: '1vh'}}>
                                                        <p>Shuffle</p>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                        <Row justify={'start'}>
                                            <Button className={'hard-btn'}
                                                    style={{
                                                        width: '8vw',
                                                        marginLeft: '-1.6vw'
                                                    }}
                                                    onClick={() => {
                                                        navigate('/proportal/images', {
                                                            state: {
                                                                textura_ids: [deviceData.id],
                                                                title: 'Select artwork to the current playlist',
                                                                filter: -1,
                                                                checkMode: true
                                                            }
                                                        })
                                                    }}
                                            >
                                                Add Artwork
                                            </Button>
                                            <Button className={'hard-btn'}
                                                    style={{
                                                        width: '9vw',
                                                        marginLeft: '2vw'
                                                    }}
                                                    onClick={() => {
                                                        navigate('/proportal/images', {
                                                            state: {
                                                                textura_ids: [deviceData.id],
                                                                title: 'Please Remove Artworks',
                                                                filter: 'current',
                                                                checkMode: true,
                                                                removeMode: true,
                                                            }
                                                        })
                                                    }}
                                            >
                                                Remove Artwork
                                            </Button>
                                        </Row>
                                    </div>}

                                </Col>
                            </Row>
                            <Row>
                                <Button className={'hard-btn'}
                                        style={{
                                            width: '199.685px',
                                            margin: '2rem 0 2rem 6rem',
                                            display: cur === 0 ? 'flex' : 'none'
                                        }}
                                        onClick={() => {
                                            setNewScheduleOpen(true)
                                            setInfoChanged(true)
                                        }}
                                >
                                    Add New Schedule
                                </Button>
                            </Row>
                            <Row className={'hard-week-above-row'} style={{
                                display: newScheduleOpen && cur === 0 ? 'flex' : 'none',
                            }}>
                                <span className={'hard-st-time-txt'}>Start time:</span>
                                <span className={'hard-end-time-txt'}>End time:</span>
                            </Row>
                            <Row className={'hard-week-row'} style={{
                                display: newScheduleOpen && cur === 0 ? 'flex' : 'none',
                            }}>
                                <TimePicker className={'hard-input-week'}
                                            onChange={(time, timeString) =>
                                                dispatch({type: 'add_schedule', item: {start_time: timeString}})
                                            }
                                            format="HH:mm"
                                />
                                <TimePicker className={'hard-input-week'}
                                            onChange={(time, timeString) =>
                                                dispatch({type: 'add_schedule', item: {end_time: timeString}})
                                            }
                                            format="HH:mm"
                                />
                                {DAYS_A_WEEK.map((day, index) => (
                                    <div
                                        key={index}
                                        className={'hard-week-btn'}
                                        style={{backgroundColor: dsState.schedule.days.includes(index) ? '#0E487A' : '#D9D9D9',}}
                                        onClick={() => {
                                            const newDays = dsState.schedule.days.includes(index)
                                                ? dsState.schedule.days.filter(d => d !== index)
                                                : [...dsState.schedule.days, index];
                                            dispatch({type: 'add_schedule', item: {days: newDays}})
                                        }}
                                    >
                                        {day}
                                    </div>
                                ))}
                            </Row>
                            <Row className={'hard-final-row'}
                                 style={{
                                     marginTop: cur === 0 ? '0' : '4rem',
                                     display: infoChanged && cur !== 2 ? 'flex' : 'none',
                                 }}>
                                <Button className={'hard-week-final-btn'}
                                        onClick={() => {
                                            const curId = [deviceData.id]
                                            post_api('/textura/create/schedule', {
                                                "textura_ids": curId,
                                                ...dsState.schedule
                                            }).then(_ => window.location.reload()).catch(error => console.error('Error:', error));
                                        }}
                                >
                                    Save
                                </Button>
                                <Button className={'hard-week-final-btn'}
                                        onClick={() => {
                                            window.location.href = '/proportal/dashboard'
                                        }}
                                >
                                    Close
                                </Button>
                            </Row>
                            <Row className={'hard-final-row'}
                                 style={{
                                     marginTop: cur === 0 ? '0' : '4rem',
                                     display: nameChanged && cur !== 2 ? 'flex' : 'none',
                                 }}>
                                <Button className={'hard-week-final-btn'}
                                        onClick={() => {
                                            const curId = deviceData.id
                                            post_api('/textura/change/textura/name', {
                                                "textura_id": curId,
                                                new_textura_name: deviceName
                                            })
                                                // .then(_ => window.location.reload())
                                                .catch(error => console.error('Error:', error));
                                        }}
                                >
                                    Save
                                </Button>
                                <Button className={'hard-week-final-btn'}
                                        onClick={() => {
                                            window.location.href = '/proportal/dashboard'
                                        }}
                                >
                                    Close
                                </Button>
                            </Row>
                        </Layout>
                    </Layout>
                </Row>
            </Content>
        </Layout>
    )
}

export default Hardware;
